import { QuestionStatus } from '@exam-management/graphql';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { Flex, SectionTitle } from '@shared/components';

import { useSingleQuestionDetails } from '../../providers';
import { InformationFormSection } from '../information-form-section';
import { InformationView } from '../information-view';

export default function SingleQuestionInformationSection() {
  const { roles, status } = useQuestionCreationTaskDetails();
  const { singleQuestion } = useSingleQuestionDetails();

  const isInDevelopment = singleQuestion.status === QuestionStatus.InDevelopment;

  const isEditable =
    isInDevelopment &&
    roles.isAssignee &&
    status.code === QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Information' />
      {isEditable ? <InformationFormSection /> : <InformationView />}
    </Flex>
  );
}
